import * as actionTypes from '../actions/actionTypes';

const initialState = {
    name: null,
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.PASSWORD_CHANGE_INITIALIZE:
            return {
                ...state,
                loading: null,
                error: null,
                name: null
            };
        case actionTypes.PASSWORD_CHANGE_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                name: null
            };
        case actionTypes.PASSWORD_CHANGE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                name: null
            };
        case actionTypes.PASSWORD_CHANGE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                name: action.payload
            };
        default:
            return state;
    }
};

export default reducer;